/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState, useEffect} from 'react'
import {
    Button,
    Divider,
    Flex,
    Image,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import ProductRegistrationFields from '../../product-registration/partials/forms/product-registration-fields'
import {useForm} from 'react-hook-form'
import {useProduct} from '@salesforce/commerce-sdk-react'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'

const ProductRegisteredEditForm = ({goBack, product, confirmEdit, isGuest, confirmDelete}) => {
    const [receiptBase64, setReceiptBase64] = useState('')
    const [receiptName, setReceiptName] = useState('')
    const [receiptMime, setReceiptMime] = useState('')
    const [receiptFile, setReceiptFile] = useState(null) // Add state for the file object
    const [fileError, setFileError] = useState('') // Add state for file validation error
    const {currency: activeCurrency} = useCurrency()
    const {
        data: productData,
        isLoading,
        error,
    } = useProduct({
        parameters: {
            id: product?.skuKut,
            allImages: false,
            currency: activeCurrency,
        },
    })
    const largeImage = productData?.imageGroups?.find((item) => item.viewType === 'large')
        ?.images[0]?.link
    const smallImage = productData?.imageGroups?.find((item) => item.viewType === 'medium')
        ?.images[0]?.link

    const selectedProduct = product
    const form = useForm({
        defaultValues: {
            //serialNumber: product?.serialId || '',
            purchaseDate: product?.purchaseData || '',
            source: product?.source || '',
        },
    })
    const {setValue} = form
    const styles = useMultiStyleConfig('ProductRegistration', {
        variant: 'editRegisteredProductForm',
    })
    const formStyles = useMultiStyleConfig('ProductRegistrationForm', {
        variant: 'editRegisteredProductForm',
    })

    const purchaseDate = product?.referenceDate
    const [_, year, month, day] = purchaseDate
        ? purchaseDate.match(/(\d{4})(\d{2})(\d{2})/).map(Number)
        : []
    const date = new Date(year, month - 1, day)
    const formattedDate = date.toLocaleDateString('it-IT')

    useEffect(() => {
        if (selectedProduct) {
            //setValue('serialNumber', selectedProduct.serialId)
            setValue('productName', selectedProduct.productName)
            // purchasedate needs to be kept as a Date, not string
            setValue('purchasedate', date)
            setValue('source', selectedProduct.sourceKut)
            setValue('serialNumber', selectedProduct.serialNumberKut)
        }
    }, [selectedProduct, setValue])

    const onSubmit = (data) => {
        // Chiama la funzione confirmEdit passando i dati aggiornati
        confirmEdit({
            ...product,
            productName: productData?.name,
            serialId: data.serialNumber,
            purchaseData: data.purchasedate,
            source: data?.source?.value,
            receiptBase64,
            receiptName,
            receiptMime,
        })
    }

    if (isGuest && !product) {
        return
    }

    return (
        <Flex {...styles.container}>
            {!isGuest && (
                <Flex {...styles.headerStepperContainer}>
                    <Button variant="text-button" onClick={goBack} {...styles.headerBackButton}>
                        <FormattedMessage
                            id="product_registration_form.back_to_registered_products"
                            defaultMessage="Back to registered products"
                        />
                    </Button>
                    <Text {...styles.headerTitle} as="h2">
                        <FormattedMessage
                            id="product_registration_form.complete_edit_registered_product"
                            defaultMessage="Update details"
                        />
                    </Text>
                </Flex>
            )}

            {/* <Flex {...styles.labelSearchInnerContainer}>
                <Text {...styles.labelSearchTitle}>
                    <FormattedMessage
                        id="product_registration_form.add_purchase_details"
                        defaultMessage="Add purchase details"
                    />
                </Text>
            </Flex> */}
            <Flex {...formStyles.outerContainer}>
                <Flex {...formStyles.innerContainer}>
                    <Image
                        display={['none', 'none', 'none', 'block']}
                        {...formStyles.image}
                        src={largeImage}
                        alt={product?.productName}
                    />
                    <Flex {...formStyles.formContainer}>
                        <Image
                            display={['block', 'block', 'block', 'none']}
                            {...formStyles.image}
                            src={smallImage}
                            alt={product?.productName}
                        />
                        <Text {...formStyles.titleText}>{productData?.name}</Text>
                        <Text {...formStyles.detailText}>
                            <FormattedMessage
                                id="product_registration_form.registration_details"
                                defaultMessage="Registration details"
                            />
                        </Text>
                        <Text {...formStyles.purchaseText}>
                            <FormattedMessage
                                id="product_registration_form.purchase_date_info"
                                defaultMessage="The purchase date cannot be changed, please delete the product registration and create a new one"
                            />
                        </Text>
                        <ProductRegistrationFields
                            form={form}
                            setReceiptBase64={setReceiptBase64}
                            setReceiptName={setReceiptName}
                            setReceiptMime={setReceiptMime}
                            initialFile={product.registeredProductAttachmentFolder}
                            isEditForm={true}
                            isGuest={isGuest}
                            isAccount={true}
                            setReceiptFile={setReceiptFile}
                            fileError={fileError}
                            setFileError={setFileError}
                        />
                    </Flex>
                </Flex>
                <Divider {...formStyles.horizontalDivider} />
            </Flex>
            <Flex {...formStyles.buttonContainer}>
                {isGuest ? (
                    <Button
                        {...formStyles.formButton}
                        variant={'primary'}
                        onClick={() => confirmDelete(product)}
                    >
                        <Text {...formStyles.buttonText}>
                            <FormattedMessage
                                id="product_registration_form.delete_registered_product"
                                defaultMessage="Delete"
                            />
                        </Text>
                    </Button>
                ) : (
                    <>
                        <Button
                            {...formStyles.formButtonSecondary}
                            variant={'secondary'}
                            onClick={goBack}
                        >
                            <Text {...formStyles.buttonText}>
                                <FormattedMessage
                                    id="product_registration_form.abort_edit_registered_product"
                                    defaultMessage="Cancel"
                                />
                            </Text>
                        </Button>
                        <Button
                            {...formStyles.formButton}
                            variant={'primary'}
                            onClick={form.handleSubmit(onSubmit)}
                            data-testid="update-details-button"
                        >
                            <Text {...formStyles.buttonText}>
                                <FormattedMessage
                                    id="product_registration_form.complete_edit_registered_product"
                                    defaultMessage="Update details"
                                />
                            </Text>
                        </Button>
                    </>
                )}
            </Flex>
        </Flex>
    )
}

ProductRegisteredEditForm.propTypes = {
    product: PropTypes.object,
    variant: PropTypes.string,
    selectedProduct: PropTypes.object,
    goBack: PropTypes.func,
    confirmEdit: PropTypes.func.isRequired,
    isGuest: PropTypes.bool,
    confirmDelete: PropTypes.func,
}

export default ProductRegisteredEditForm
